import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button
}                         from "react-bootstrap";
import axios              from "axios";
import {
    ToastContainer,
    toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_VALID
}                         from "utils";

import CrudComponent      from "../zynappse-crud";
import BeaconSchema       from "./BeaconSchema";
import saveTrail          from "utils/saveTrail";
import FormContainer      from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class Beacon extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;

        this.refreshTable = this.refreshTable.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
    }

    refreshTable () {
        if (
            IS_VALID(IS_VALID) &&
            typeof this.refreshTableReference === "function"
        ) {
            this.refreshTableReference();
        }
    }

    saveData () {
        let {
            Beacon,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId,

            uuid,
            major,
            minor,
            hexNamespace,
            hexInstance
        } = Beacon;

        if (
            !IS_VALID(uuid) ||
            !IS_VALID(uuid.trim())
        ) {
            toast.error("UUID is required.");
        } else if (
            !IS_VALID(major)
        ) {
            toast.error("Major is required.");
        } else if (
            !IS_VALID(minor)
        ) {
            toast.error("Minor is required.");
        } else if (
            !IS_VALID(hexNamespace) ||
            !IS_VALID(hexNamespace.trim())
        ) {
            toast.error("Hex Namespace is required.");
        } else if (
            !IS_VALID(hexInstance) ||
            !IS_VALID(hexInstance.trim())
        ) {
            toast.error("Hex Instance is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let beacon = new Parse.Object("Beacon");

            if (
                formType === "UPDATE" &&
                selectedData
            ) {
                beacon = selectedData;
            }

            let data = {
                uuid: uuid.trim(),
                major: parseInt(major),
                minor: parseInt(minor),
                hexNamespace: hexNamespace.trim(),
                hexInstance: hexInstance.trim()
            };

            for (let key in data) {
                if (
                    !IS_VALID(beacon.get(key)) ||
                    beacon.get(key) !== data[key]
                    ) {
                    beacon.set(key, data[key]);
                }
            }

            let dirtyKeys = beacon.dirtyKeys();

            let changesObject = {
                objectId: beacon.id
            };

            for (let key of dirtyKeys) {
                changesObject[key] = IS_UNDEFINED(beacon.get(key)) ? "unset" : beacon.get(key);
            }

            beacon.save()
            .then((data) => {
                changesObject.objectId = data.id;

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });
                
                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    changesObject
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            })
        }
    }

    deleteData () {
        let {
            Beacon,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId
        } = Beacon;

        actions.setValue({
            isLoadingAction: true
        });

        selectedData.destroy()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                formType.toUpperCase(),
                {
                    objectId: selectedData.id,
                    uuid: selectedData.get("uuid"),
                    major: selectedData.get("major"),
                    minor: selectedData.get("minor"),
                    hexNamespace: selectedData.get("hexNamespace"),
                    hexInstance: selectedData.get("hexInstance")
                }
            );
        })
        .catch((err) => {
            console.log("deleteData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        });
    }

    renderModalButton () {
        let {
            Beacon,
            actions
        } = this.props;
        
        let {
            isLoadingAction,
            formType
        } = Beacon;
        let buttons = [],
            buttonAction = (
                name = "CREATE",
                loading = isLoadingAction,
                callback = this.saveData
            ) => (
                <Button
                    bsStyle="primary"
                    disabled={loading}
                    onClick={() => callback()}
                >
                    {name}
                </Button>
            ),
            buttonClose = (
                <Button
                    disabled={isLoadingAction}
                    onClick={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                    CLOSE
                </Button>
            );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    buttonAction(
                        "CREATE",
                        isLoadingAction
                    ),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    buttonAction(
                        "UPDATE",
                        isLoadingAction
                    ),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    buttonAction(
                        "DELETE",
                        isLoadingAction,
                        this.deleteData
                    ),
                    buttonClose
                );
                break;
            default:
                buttons.push(
                    buttonClose
                );
                break;
        }
        
        return buttons;
    }

    render () {
        let {
            Beacon,
            accessjson,
            actions
        } = this.props;

        let {
            showModal,
            isLoadingAction,
            selectedData,
            formType,
            formTitle
        } = Beacon;

        let crudProps = {
            schema: BeaconSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "descending", column: "createdAt" }
            ],
            saveTrail: saveTrail,
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE BEACON"
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE BEACON",
                    formId: obj.id,
                    selectedData: obj
                };

                if (IS_VALID(obj.get("uuid"))) {
                    stateToUpdate.uuid = obj.get("uuid");
                }

                if (IS_VALID(obj.get("major"))) {
                    stateToUpdate.major = obj.get("major");
                }

                if (IS_VALID(obj.get("minor"))) {
                    stateToUpdate.minor = obj.get("minor");
                }

                if (IS_VALID(obj.get("hexNamespace"))) {
                    stateToUpdate.hexNamespace = obj.get("hexNamespace");
                }

                if (IS_VALID(obj.get("hexInstance"))) {
                    stateToUpdate.hexInstance = obj.get("hexInstance");
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) =>{
                actions.setValue({
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE BEACON",
                    formId: obj.id,
                    selectedData: obj
                });
            }
        };

        let formContainerProps = {
            actions,

            selectedData,
            formType
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading
                        style={{
                            backgroundColor: '#D1282F',
                            color: 'white'
                        }}
                    >
                         <h4 style={{ display: "inline-block" }}>Beacon</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent
                            {...crudProps}
                        />
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            })
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer
                            {...formContainerProps}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_BEACON
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        accessjson,
        Beacon
	} = state;

	return {
        accessjson,
        Beacon
	};
}

function mapDispatchToProps(dispatch) {
    const actions = {
      setValue: (stateObject, actionType = SET_BEACON) => generics.setValue(actionType, stateObject)
    };
  
    return {
      actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Beacon);


// WEBPACK FOOTER //
// ./components/Beacon/index.js